import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { Message } from 'semantic-ui-react';
import { searchContent, resetSearchContent } from '@plone/volto/actions';
import { flattenToAppURL } from '@plone/volto/helpers/Url/Url';
import { contentFolderHasItems } from '@redturtle/iovisit-theme/helpers';
import SliderVariation from '@redturtle/iovisit-theme/components/Blocks/Listing/Slider/Slider';

const Body = ({ data, properties, isEditMode }) => {
  const { folder_name = 'multimedia', title } = data;
  const dispatch = useDispatch();

  const content = properties;
  const url = content?.['@id']
    ? `${flattenToAppURL(content['@id'])}/${folder_name}`
    : null;

  const searchResults = useSelector((state) => state.search.subrequests);
  const hasChildren = contentFolderHasItems(content, folder_name);

  useEffect(() => {
    if (hasChildren) {
      dispatch(
        searchContent(
          url,
          {
            'path.depth': 1,
            sort_on: 'getObjPositionInParent',
            metadata_fields: '_all',
            fullobjects: 1,
          },
          folder_name,
        ),
      );
    }
    return () => {
      dispatch(resetSearchContent(folder_name));
    };
  }, [dispatch, folder_name, hasChildren, url]);

  const multimedia = searchResults?.[folder_name]?.items || [];
  let images = multimedia.filter((item) => item['@type'] === 'Image');

  return !hasChildren ? (
    isEditMode ? (
      <Message size="mini">
        Gallery: Nessuna immagine da mostrare nella cartella Multimedia.
        <br />
        Questo blocco non verrà mostrato in visualizzazione.
      </Message>
    ) : null
  ) : (
    <div className="block multimedia-folder-gallery">
      {title && <h2>{title}</h2>}

      <SliderVariation
        items={images}
        size="s"
        show_item_title={false}
        show_item_description={false}
        show_detail_link={false}
        square_images={true}
        slidesToShow={4}
      />
    </div>
  );
};
export default Body;
